import React, { useState, useEffect } from "react";
import {
  Nav,
  NavLink,
  NavbarContainer,
  Span,
  NavLogo,
  NavItems,
  GitHubButton,
  ButtonContainer,
  MobileIcon,
  MobileMenu,
  MobileLink,
} from "./NavbarStyledComponent";
import { DiCssdeck } from "react-icons/di";
import { FaBars, FaTimes } from "react-icons/fa";
import { Bio } from "../../data/constants";
import { useTheme } from "styled-components";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("about");
  const theme = useTheme();

  // Function to handle smooth scrolling + update URL
  const handleScrollTo = (id, e) => {
    if (e) e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      // update URL without reloading page
      window.history.pushState(null, "", `/${id}`);
    }
    setIsOpen(false);
  };

  // Detect which section is in view
  useEffect(() => {
    const handleScroll = () => {
      const sections = [
        "about",
        "skills",
        "experience",
        "projects",
        "education",
      ];
      const scrollPosition = window.scrollY + 100;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const offsetTop = element.offsetTop;
          const offsetBottom = offsetTop + element.offsetHeight;

          if (scrollPosition >= offsetTop && scrollPosition < offsetBottom) {
            setActiveSection(section);
            // update URL on scroll
            window.history.replaceState(null, "", `/${section}`);
            break;
          }
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Nav>
      <NavbarContainer>
        <NavLogo to="/">
          <a
            style={{
              display: "flex",
              alignItems: "center",
              color: "orange",
              marginBottom: "20px",
              cursor: "pointer",
              textDecoration: "none",
            }}
            onClick={(e) => handleScrollTo("about", e)}
          >
            <Span
              style={{
                fontSize: "1.5rem",
                fontWeight: "bold",
                letterSpacing: "-0.5px",
              }}
            >
              <span style={{ opacity: 0.7 }}>SA</span> | {Bio.name}
            </Span>
          </a>
        </NavLogo>

        <MobileIcon>
          <FaBars onClick={() => setIsOpen(!isOpen)} />
        </MobileIcon>

        <NavItems>
          <NavLink
            onClick={(e) => handleScrollTo("about", e)}
            className={activeSection === "about" ? "active" : ""}
          >
            About
          </NavLink>
          <NavLink
            onClick={(e) => handleScrollTo("skills", e)}
            className={activeSection === "skills" ? "active" : ""}
          >
            Skills
          </NavLink>
          <NavLink
            onClick={(e) => handleScrollTo("experience", e)}
            className={activeSection === "experience" ? "active" : ""}
          >
            Experience
          </NavLink>
          <NavLink
            onClick={(e) => handleScrollTo("projects", e)}
            className={activeSection === "projects" ? "active" : ""}
          >
            Projects
          </NavLink>
          <NavLink
            onClick={(e) => handleScrollTo("education", e)}
            className={activeSection === "education" ? "active" : ""}
          >
            Education
          </NavLink>
        </NavItems>

        <ButtonContainer>
          <GitHubButton
            href={Bio.github}
            target="_blank"
            rel="noopener noreferrer"
          >
            Github Profile
          </GitHubButton>
        </ButtonContainer>

        {isOpen && (
          <MobileMenu isOpen={isOpen}>
            <FaTimes
              style={{
                position: "absolute",
                top: "20px",
                right: "20px",
                cursor: "pointer",
                fontSize: "1.5rem",
              }}
              onClick={() => setIsOpen(false)}
            />
            <MobileLink
              onClick={(e) => handleScrollTo("about", e)}
              className={activeSection === "about" ? "active" : ""}
            >
              About
            </MobileLink>
            <MobileLink
              onClick={(e) => handleScrollTo("skills", e)}
              className={activeSection === "skills" ? "active" : ""}
            >
              Skills
            </MobileLink>
            <MobileLink
              onClick={(e) => handleScrollTo("experience", e)}
              className={activeSection === "experience" ? "active" : ""}
            >
              Experience
            </MobileLink>
            <MobileLink
              onClick={(e) => handleScrollTo("projects", e)}
              className={activeSection === "projects" ? "active" : ""}
            >
              Projects
            </MobileLink>
            <MobileLink
              onClick={(e) => handleScrollTo("education", e)}
              className={activeSection === "education" ? "active" : ""}
            >
              Education
            </MobileLink>
            <GitHubButton
              style={{
                padding: "10px 16px",
                background: `${theme.primary}`,
                color: "white",
                width: "max-content",
                marginTop: "20px",
              }}
              href={Bio.github}
              target="_blank"
              rel="noopener noreferrer"
            >
              Github Profile
            </GitHubButton>
          </MobileMenu>
        )}
      </NavbarContainer>
    </Nav>
  );
};

export default Navbar;
